import React from 'react'
import cx from 'classnames'

import './ui.scss'

const Label = ({
  className,
  required,
  ...props
}) => {
  const classes = cx('m-label', className, {
    'm-label--required': required,
  })

  return (
    <label className={classes} {...props} />
  )
}

export default Label
